import { ModuleModeEnum } from '@/enums/ModuleModeEnum';

export default {
    indicator: ({ values }: { values: { mode: ModuleModeEnum } }) => {
        const { mode } = values;
        return `Please read the highlighted section aloud.
                    ${mode === ModuleModeEnum.SELF ? 'Click on the passage to move to the next section.' : ''}`;
    },
    intro: {
        content: {
            loud: 'Read the highlighted section aloud!',
            readingType1: "Let's read together with Guided Reading in {readingType}.",
            readingType2: "Let's do Guided Reading in {readingType}.",
            teacherAndStudents:
                'Teacher, please read the yellow-highlighted parts aloud, and Students, please read the blue-highlighted parts aloud!',
            start: 'Shall we start Guided Reading in {readingType}?',
            students: '{students}, please read the highlighted section aloud!',
        },
        othersCount: 'and {count} others',
    },
    options: {
        title: 'Title',
        readingType: {
            label: 'Reading Unit',
            unit: 'Unit',
            meaning: 'Meaning',
            sentence: 'Sentence',
            paragraph: 'Paragraph',
        },
        readingMode: {
            label: 'Reading Mode',
            all: 'Read All Together',
            split: 'Split Reading',
            random: 'Take Turns (Random)',
            selected: 'Take Turns (Assigned)',
        },
        example: {
            all: 'Everyone Together',
            teacher: 'Teacher',
            students: 'Students',
        },
        textbook: 'Textbook passages',
    },
    setting: {
        readerCount: 'Number of readers',
        draw: 'Draw',
        redraw: 'Draw again',
        resetSelection: 'Reset selection',
        randomOrderNotice: 'ⓘ The order is assigned randomly.',
        connectedCount: '{count} online',
        personCount: '{count}',
        unit: '',
    },
    inplay: {
        reading: 'Reading',
        readingCount: '{count}',
        fontDown: 'A -',
        fontUp: 'A +',
        me: 'Me',
    },
    buttons: {
        next: 'Next Lesson',
        assign: 'Assign Students',
        assignStudents: 'Assign Students',
        fontSize: 'Font Size',
    },
    result: {
        done: 'Guided Reading is complete!',
        lecture: {
            all: '"All Students" read in "{readingType}" units.',
            split: 'Read together with "Teacher" in "{readingType}" units.',
            random: '{students} read in "{readingType}" units.',
            selected: '{students} read in "{readingType}" units.',
            averageTime: '{time} elapsed',
        },
        self: {
            all: 'All Students read in {readingType}.',
            split: 'Read together with Teacher in {readingType}.',
            random: '{students} read in {readingType}.',
            selected: '{students} read in {readingType}.',
            averageTime: 'Average {time} elapsed',
            inplay: 'Progressing with "{readingMode}" in "{readingType}" units.',
        },
    },
    teacherFooter: {
        done: 'Finished reading.',
        click: 'Please click on the passage area.',
    },
    pageRange: 'pp. {startPage}–{endPage}',
};
